import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { PageHeaderProvider } from "./contexts/PageHeaderContext";
import { UserContextProvider } from "./contexts/UserContext";
import routes from "./routes";
import reportWebVitals from "./utils/reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container!);

const router = createBrowserRouter(routes);

root.render(
  <UserContextProvider>
    <PageHeaderProvider>
      <RouterProvider router={router} />
    </PageHeaderProvider>
  </UserContextProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
